const defaultSettings = {
  rows: 0,
  lazyLoad: 'ondemand',
  // responsive: [
  //   {
  //     breakpoint: 767,
  //     settings: {
  //       slidesToShow: 1,
  //     }
  //   }
  // ]
}
// SLICK CONFIG ONE SLIDE
const defaultDotsSettings = Object.assign({}, defaultSettings, { dots: true });
const defaultNotArrowsSettings = Object.assign({}, defaultSettings, { arrows: false });
const defaultNotArrowsDotsSettings = Object.assign({}, defaultDotsSettings, { arrows: false });

// SLICK CONFIG TWO SLIDES
const twoSlideSettings = Object.assign({}, { slidesToShow: 2 });

// SLICK CONFIG THREE SLIDES
const threeSlideSettings = Object.assign({}, { slidesToShow: 3 });

// SLICK CONFIG FOUR SLIDES
const fourSlideSettings = Object.assign({}, { slidesToShow: 4 });


// ONE SLIDE
$('.carousel-oneslide').slick(defaultSettings);
$('.carousel-oneslide-dots').slick(defaultDotsSettings);
$('.carousel-oneslide-noarrow').slick(defaultNotArrowsSettings);
$('.carousel-oneslide-noarrow-dots').slick(defaultNotArrowsDotsSettings);

// TWO SLIDES
// $('.carousel-twoslides').slick(twoSlideSettings);
// $('.carousel-twoslides-noarrow-dots').slick(Object.assign({}, twoSlideSettings, defaultNotArrowsDotsSettings));

// THREE SLIDES
$('.carousel-threeslides').slick(threeSlideSettings);
$('.carousel-threeslides-dots').slick(Object.assign({}, threeSlideSettings, defaultDotsSettings));
$('.carousel-threeslides-noarrow').slick(Object.assign({}, threeSlideSettings, defaultNotArrowsSettings));
$('.carousel-threeslides-noarrow-dots').slick(Object.assign({}, threeSlideSettings, defaultNotArrowsDotsSettings));

// FOUR SLIDES
$('.carousel-fourslides').slick(fourSlideSettings);
$('.carousel-fourslides-noarrow').slick(Object.assign({}, fourSlideSettings, defaultNotArrowsSettings));
$('.carousel-fourslides-noarrow-dots').slick(Object.assign({}, fourSlideSettings, defaultNotArrowsDotsSettings));


// SLIDER NAV - SLIDER FOR
$('.carousel-slider-nav').slick({
    rows: 0,
    slidesToScroll: 1,
    arrows: true,
    infinite:false,
    // centerMode: true,
    // centerPadding: '',
    variableWidth: true,
    focusOnSelect: true,
    asNavFor: '.carousel-slider-for',
    responsive: []
});
$('.carousel-slider-for').slick({
    rows: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite:false,
    fade: true,
    asNavFor: '.carousel-slider-nav',
    responsive: []
});

// END SLIDER NAV - SLIDER FOR


// CUSTOM CAROUSEL
$('.carousel-variableWidth').slick({
  rows: 0,
  centerMode: true,
  centerPadding: '',
  swipeToSlide: true,
  variableWidth: true
});
$('.carousel-variableWidth-noarrow-dots').slick({
  rows: 0,
  centerMode: true,
  centerPadding: '',
  swipeToSlide: true,
  dots: true,
  arrows: false,
  variableWidth: true
});

$('.carousel-fourslides-noarrow-dots-autoplay').slick({
  rows: 0,
  slidesToShow: 4,
  swipeToSlide: true,
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 1500,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
});


// CUSTOM CLASS ONE SLIDE CSS
$('.carousel-internal-arrow').slick(defaultSettings);

// CUSTOM CAROUSEL NUMBERS
$('.carousel-numbers').on('init', function () {
  $(this).append('<div class="carousel-numbers-item"></div>')   
}).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  var i = (currentSlide ? currentSlide : 0) + 1;
  $(this).find('.carousel-numbers-item').text(i + ' di ' + (slick.$slides.length));
}).slick(defaultSettings);



// CONTROLLARE
/*$('.carousel-structure').slick({
  rows: 0,
  centerMode: true,
  centerPadding: '',
  variableWidth: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: false
      }
    }
  ]
});
$('.section-carousel-structure .nav-link').on('click', function() {
    var items = $(this).attr('data-filter');
    if(items == 'all') {
        $('.carousel-structure').slick('slickUnfilter');
    } else {
        $('.carousel-structure').slick('slickUnfilter');
        $('.carousel-structure').slick('slickFilter', items);
    }
});*/

$('.carousel-offer-md').slick({
    rows: 2,
    slidesPerRow: 1,
    dots: true,
    arrows: true,
    centerMode: true,
    centerPadding: '',
    variableWidth: true,
});

$('.carousel-offer-sm').slick({
    rows: 0,
    dots: true,
    arrows: false,
    centerMode: true,
    centerPadding: '',
});


$(function() {
  
// STRUCTURE HOME
$('.carousel-structure').slickFilterable({
  filterName: 'catalogfilter',
  filter: function(category, slider, settings) {
    return $(this).data('catalog') == category;
  }, 
  slick: {
    rows: 0,
    centerMode: true,
    centerPadding: '',
    variableWidth: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          swipe: true,
          arrows: false
        }
      }
    ]
  }
});
//END STRUCTURE HOME

$('.carousel-destination').slickFilterable({
    filterName: 'filter',
    // $('#slick-slider').slick('refresh');
    filter: function(category, slider, settings) {
      return $(this).data('destfilter') == category;
    }, 
/*     filter: function(category, slider, settings) { 
      if(!$(this).hasClass(category) && category != 'tutte')
      {
        $(this).addClass('offernotsel')
        // $(this).slick()
      }
      else {
        $(this).removeClass('offernotsel')
      }
      return true
        // return $(this).hasClass(category);
    },  */
    slick: {
        rows: 0,
        // slidesPerRow: 1,
        // slidesToShow: 2,
        centerMode: true,
        centerPadding: '',
        arrows: true,
        variableWidth: true,
        // infinite: true,
        centerMode: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                        // rows: 0,
                        // variableWidth: true,
                        arrows: false,
                        infinite: true,
                    }
                }
        ]}
    });
});


$('.carousel-brand-details').slick({
  rows: 0,
  //slidesPerRow: 5,
  swipeToSlide: true,
  arrows: false,
  variableWidth: true,
  autoplay: true,
  autoplaySpeed: 1500,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        centerPadding: '',
      }
    }
  ]
});
// FINE CONTROLLARE


$('.carousel-flip').slick({
  rows: 0,
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        vertical: true,
        centerMode: true,
        centerPadding: '',
      }
    }
  ]
})


$('.carousel-structure-rooms').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  // if(!slick.$dots) { return; }
  var i = (currentSlide ? currentSlide : 0) + 1;
  $('.carousel-structure-rooms.slider-for').find('.slick-dots').css('display','none');
  $('.typology-room').empty().text('Camera ' + structure_name[i-1]);
  if(slick.$dots) {
    $('.carousel-structure-rooms-numbers').text(i + ' di ' + (slick.$dots[0].children.length));
  } else {
    $('.carousel-structure-rooms-header').find('.carousel-numbers-item').css('display','none');
  }
});
$('.carousel-structure-rooms-header .prev').on('click', function() {
  $('.carousel-structure-rooms.slider-for').slick('slickPrev');
  $('.carousel-structure-rooms.slider-nav').slick('slickPrev');
});
$('.carousel-structure-rooms-header .next').on('click', function() {
  $('.carousel-structure-rooms.slider-for').slick('slickNext');
  $('.carousel-structure-rooms.slider-nav').slick('slickNext');
});
$('.carousel-structure-rooms.slider-for').slick({
  rows: 0,
  centerMode: true,
  centerPadding: '',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  asNavFor: '.carousel-structure-rooms.slider-nav'
});
$('.carousel-structure-rooms.slider-nav').slick({
  rows: 0,
  centerMode: true,
  centerPadding: '',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  asNavFor: '.carousel-structure-rooms.slider-for',
  // responsive: [
  //   {
  //     breakpoint: 767,
  //     settings: {
  //       dots: false
  //     }
  //   }
  // ]
});


/* SLICK COLLAPSE BUG COLLAPSE FIX */
$('[class*="section-structure-"] .collapse').on('show.bs.collapse', function (e) {
  $(this).find('[class^="carousel-"].slick-initialized').slick('refresh');
});
/* END SLICK COLLAPSE BUG COLLAPSE FIX */






/* SLICK FILTERABLE FOR ROWS */
$(function() {
    $.fn.slickFilterable = function( options ) {

        /**
         * A plugin to create a slick we can filter.
         *
         * If you are not using Rows you can use slickFilter
         * (check documentation) otherwise we can provide a valid filter.
         *
         * options {
         *      slideSelector    string     jQuery selector to get slides. Imetiate children by default.
         *      filterName       string     We will search for data-{filterName} clickable elements.
         *      slick            object     The slick settings. Check Slick doc.
         *      beforeFilter     function   A fuction called before filter slider. Receives the trigger element
         *                                  as this and 3 params: category (string), slider and slides (jQuery objects).
         *      filter           mix        A valid parameter to jQuery filter() function. If it's a functio we will wrap
         *                                  it and it receives the trigger element as this and 3 params: category (string),
         *                                  slider (jQuery object) and a copy of settings (extended).
         * }
         */
        // var oldCategory;
        var settings = $.extend({
            slideSelector: '> *',
            filterName: 'filter-slick',
            slick: {},
            beforeFilter: function() {},
            filter: function( element, category, slider, settings ) {
              return true;
            },
        }, options );

        return this.each(function() {
            var slider = $(this)
            var slides = slider.find( settings.slideSelector )
            var slickObj

            /**
             * Create Slick
             *
             * TIP: you should you 'slidesPerRow' instead 'slidesToShow' in grid mode (with rows)
             * to avoid slick break layout when there are less slides than on "page".
             */
            slickObj = slider.slick( settings.slick );

            // Handle Filter Click
            $('[data-' + settings.filterName + ']').on('click', function(event) {
                event.preventDefault();

                // oldCategory = settings.filterName != oldCategory ? settings.filterName : 'all'
                

                var category = $(this).data(settings.filterName),
                    newSlides = $.extend(true, {}, slides),
                    newSlickOptions;

                if ( ! category ) return;

                // Before Filter Slides
                if ( typeof settings.beforeFilter == 'function' ) {
                    settings.beforeFilter.call(this, category, slider, slides);
                }

                // Destroy and empty
                slider.slick('unslick');

                // Recreate All Slides
                // if ( oldCategory === 'all' ) {
                if ( category === 'all' ) {
                    slider.find( settings.slideSelector ).remove();
                    slider.append( newSlides );
                    slider.slick( settings.slick );

                    return;
                }

                /**
                 * Filter Slides
                 *
                 * If settings.filter is a function we pass the category, slider and a copy of settings
                 * expecting a true or false return to pass it to jQuery.filter();
                 *
                 * If not, we just pass it directly.
                 */
                if ( typeof settings.filter !== 'function' ) {
                    newSlides = newSlides.filter( settings.filter );
                } else {
                    newSlides = newSlides.filter( function() {
                        return settings.filter.call( this, category, slider, $.extend( true, {}, settings ) );
                    } );
                }

                slider.find( settings.slideSelector ).remove();
                slider.append( newSlides );
                slider.slick( settings.slick );
            });

            $('[data-' + settings.filterName + ']').on('dblclick', function(event) {
                event.preventDefault();

                if(settings.filterName != 'filter') {

                  var category = $(this).data(settings.filterName)
                  var newSlides = $.extend(true, {}, slides)
  
                  if($(this).hasClass('active')) {
                    $(this).removeClass('active')
                  }
  
                  slider.slick('unslick');
  
                  if ( typeof settings.beforeFilter == 'function' ) {
                    settings.beforeFilter.call(this, category, slider, slides);
                  }
  
                  slider.find( settings.slideSelector ).remove();
                  slider.append( newSlides );
                  slider.slick( settings.slick );
                }
                
            });
        });
    };
}(jQuery));